import { User } from '../models/user';
import { PaymentState } from '../types/payment-state';
import { CashPaymentStatus } from '../types/cash-payment-status';

export class Order {
    public orderID: number;
    public orderCode: string;
    public orderState: string;
    public providerName: string;
    public user: User;
    public modified?: Date;
    public created?: Date;
    public totalPrice: number;
    public paidTotalPrice: number;
    public deliveryDate: Date;
    public deliveryTimeSlotEnd: number;
    public isSuperOrder: boolean;
    public deliveryFee: number;
    public deliveryAddress: string;
    public deliveryTypeName: string;
    public comment: string;
    public ordererName: string;
    public superOrderCode: string;
    public billPhotoFilename: string;
    public billPhotoID: string;
    public timeSlotVisualShiftMinutes: number;
    public paymentState: PaymentState;
    public cashPaymentStatus: CashPaymentStatus;
    public estimatedDeliveryEnd?: Date;
    public estimatedPickingEnd?: Date;
    public estimatedPickingStart?: Date;
    public realDeliveryEnd?: Date;
    public realPickingEnd?: Date;
    public realPickingStart?: Date;
    public deliveryDay: string;
    public deliveryTimeSlot: string;
}
